<section id="company" class="container">
  <div class="row justify-content-center">
    <div class="col-12 col-lg-9">
      <div class="row">
        <h1>Company Information</h1>
      </div>

      <div *ngIf="company" class="row">
        <div class="row">
          <div class="field col-6">
            <label>Company Name</label>
            <p>{{ company.name }}</p>
          </div>
          <div class="field col-6">
            <label>Industry</label>
            <p>{{ company.industry }}</p>
          </div>
        </div>

        <div class="row">
          <div class="field col-6 col-lg-4">
            <label>City</label>
            <p>{{ company.city }}</p>
          </div>
          <div class="field col-6 col-lg-4">
            <label>State</label>
            <p>{{ company.state }}</p>
          </div>
          <div class="field col-6 col-lg-4">
            <label>Country</label>
            <p>{{ company.country }}</p>
          </div>
          <div class="field col-12 col-lg-4">
            <label>Status</label>
            <p>
              {{ company.status.toUpperCase() }}
            </p>
          </div>
          <div class="field col-6 col-lg-4">
            <label>Member Since</label>
            <p>{{ company.memberSince | date }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
